module.exports = __webpack_public_path__ + "static/appicon-2073950fd5afb9ac4072fd255fc1a2b0.png";